import { AssignmentActionTypes } from "./assignment.types";
import axios from "axios";
import { PAGE_SIZE } from "res/constants";


export const getAssignmentStart = () => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_START,
});

export const getAssignmentSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_SUCCESS,
  payload: data,
});

export const getAssignmentFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_FAILURE,
  payload: error,
});

export const resetAssignmentState = (error) => ({
  type: AssignmentActionTypes.RESET_ASSIGNMENT_STATE,
  payload: error,
});

export const setShowNextQuestion = (isShow) => ({
  type: AssignmentActionTypes.SET_SHOW_NEXT_QUESTION,
  payload: isShow
})

export const setAnswer = (payload) => ({
  type: AssignmentActionTypes.SET_ANSWER,
  payload: payload
})

///Get Details ByID

export const setAssignmentCounter = (counter) => ({
  type: AssignmentActionTypes.SET_ASSIGNMENT_COUNTER,
  payload: counter,
});

export const getAssignmentDetailStart = () => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_START,
});

export const getAssignmentDetailSuccess = (assignmentID, assignmentData) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_SUCCESS,
  payload: { assignmentID, assignmentData },
});

export const getAssignmentDetailResultSuccess = (assignmentResultData) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_RESULT_SUCCESS,
  payload: { assignmentResultData },
});

export const getAssignmentDetailFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_FAILURE,
  payload: error,
});

///Get Result ByID

export const getAssignmentResultDetailStart = () => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_START,
});

export const getAssignmentResultDetailSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_SUCCESS,
  payload: data,
});

export const getAssignmentResultDetailFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_FAILURE,
  payload: error,
});

///Get AssignmentResult Detail ByID

export const getAssignmentResultStart = () => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_START,
});

export const getAssignmentResultSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_SUCCESS,
  payload: data,
});

export const getAssignmentResultWarning = (data) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_WARNING,
  payload: data,
});

export const getAssignmentResultFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_FAILURE,
  payload: error,
});

///Get Answer ByID

export const getAssignmentAnswerStart = () => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_START,
});

export const getAssignmentAnswerSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_SUCCESS,
  payload: data,
});

export const getAssignmentAnswerFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_FAILURE,
  payload: error,
});


///Get Results

export const getResultsStart = () => ({
  type: AssignmentActionTypes.FETCH_RESULTS_START,
});

export const getResultsSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_RESULTS_SUCCESS,
  payload: data,
});

export const getResultsFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_RESULTS_FAILURE,
  payload: error,
});

export const resetResultsLoadMore = () => ({
  type: AssignmentActionTypes.RESET_RESULTS_LOADMORE,
});

///Get Points

export const getStudentPointsStart = () => ({
  type: AssignmentActionTypes.FETCH_STUNDENT_POINTS_START,
});

export const getStudentPointsSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_STUNDENT_POINTS_SUCCESS,
  payload: data,
});

export const getStudentPointsFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_STUNDENT_POINTS_FAILURE,
  payload: error,
});


///Post assignment

export const postAssignmentStart = () => ({
  type: AssignmentActionTypes.FETCH_POST_ASSIGNMENT_START,
});

export const postAssignmentSuccess = (data) => ({
  type: AssignmentActionTypes.FETCH_POST_ASSIGNMENT_SUCCESS,
  payload: data,
});

export const postAssignmentFailure = (error) => ({
  type: AssignmentActionTypes.FETCH_POST_ASSIGNMENT_FAILURE,
  payload: error,
});

//Reset Errors
export const resetErrors = (error) => ({
  type: AssignmentActionTypes.RESET_ERROR,
})

//Current Page
export const setCurrentPage = (currentPage) => ({
  type: AssignmentActionTypes.SET_CURRENT_PAGE,
  payload: currentPage,

});

//AssignmentType
export const setAssignmentType = (assignmentMode) => ({
  type: AssignmentActionTypes.SET_ASSIGNMENT_MODE,
  payload: assignmentMode,

});

//reset plan offset
export const resetPlanOffset = () => ({
  type: AssignmentActionTypes.RESET_PLAN_OFFSET,

});
//reset result offset
export const resetResultOffset = () => ({
  type: AssignmentActionTypes.RESET_RESULT_OFFSET,

});

//set result offset
export const setResultOffset = (pageIndex) => ({
  type: AssignmentActionTypes.SET_RESULT_OFFSET,
  payload: pageIndex

});


export const getAssignmentStartAsync = ({
  studentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getAssignmentStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/GetCurrent?semesterId=${semesterID}&pageIndex=${assignment ? assignment.offset : 1}&pageSize=${PAGE_SIZE}&studentId=${studentID}`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getAssignmentSuccess(response.data.data));
        } else {
          dispatch(getAssignmentFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getAssignmentFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`url=api/parent/v1.0/AssignmentResult/GetCurrent?semesterId=${semesterID}&pageIndex=${assignment ? assignment.offset : 1}&pageSize=${PAGE_SIZE}&studentId=${studentID}&error:${error}`)

      });
  };
};



export const getAssignmentDetailStartAsync = ({
  studentID, assignmentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getAssignmentDetailStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/${semesterID}/${studentID}/${assignmentID}/StartAssignment`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getAssignmentDetailSuccess(assignmentID, response.data.data));
        } else {
          dispatch(getAssignmentDetailFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getAssignmentDetailFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};


export const getAssignmentResultDetailStartAsync = ({
  studentID, assignmentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getAssignmentDetailStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/${semesterID}/${studentID}/${assignmentID}/Details`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getAssignmentDetailResultSuccess(response.data.data));
        } else {
          dispatch(getAssignmentDetailFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getAssignmentDetailFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};


export const getResultsStartAsync = ({
  studentID, semesterID, isShowArchived = false, pageIndex = null
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getResultsStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/GetOldAssignment?semesterId=${semesterID}&pageIndex=${pageIndex || assignment.resultOffset}&pageSize=${PAGE_SIZE}&studentId=${studentID}&isShowArchived=${isShowArchived}`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getResultsSuccess(response.data.data));
        } else {
          dispatch(getResultsFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getResultsFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`url=/api/parent/v1.0/AssignmentResult/GetOldAssignment?semesterId=${semesterID}&pageIndex=${pageIndex || assignment.resultOffset}&pageSize=${PAGE_SIZE}&studentId=${studentID}&isShowArchived=${isShowArchived}&error:${error}`)

      });
  };
};
export const getStundetPointsStartAsync = ({
  studentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getStudentPointsStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/GetScoresAssignment/${semesterID}/${studentID}`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(getStudentPointsSuccess(response.data.data));
        } else {
          dispatch(getStudentPointsFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getStudentPointsFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};

export const postAssignmentStartAsync = ({
  studentID, assignmentID, body, onSuccess, semesterID
}) => {
  return (dispatch, getState) => {
    dispatch(postAssignmentStart());
    axios
      .post(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/${semesterID}/${studentID}/${assignmentID}/FinishAssignment`, body
      )
      .then((response) => {
        if (response.data.isSuccess) {
          dispatch(postAssignmentSuccess());
          onSuccess()
        } else {
          dispatch(postAssignmentFailure(response.data.message))
          throw new Error(response.data.message)
        }
      })
      .catch((error) => {
        dispatch(postAssignmentFailure(error?.response?.data?.message || 'خطا'))
        throw new Error(`studentID:${studentID}&url=api/parent/v1.0/AssignmentResult/${semesterID}/${studentID}/${assignmentID}/FinishAssignment&error:${error}&body=${JSON.stringify(body)}`)

      });
  };
};

export const getAssignmentResultStartAsync = ({
  studentID, assignmentID, semesterID
}) => {
  return (dispatch, getState) => {
    const { assignment } = getState();
    dispatch(getAssignmentResultStart());
    axios
      .get(
        `${process.env.NEXT_PUBLIC_APP_URL
        }/api/parent/v1.0/AssignmentResult/${semesterID}/${studentID}/${assignmentID}/WorkBook`
      )
      .then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data) {
            dispatch(getAssignmentResultSuccess(response.data.data));
          } else {
            dispatch(getAssignmentResultWarning(response.data.message));
          }
        } else {
          dispatch(getAssignmentResultFailure(response.data.message))
        }
      })
      .catch((error) => {
        dispatch(getAssignmentResultFailure(error?.response?.data?.message || 'خطا'))
      });
  };
};
